<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <px-nota-fiscal-danfe-btn :nota-fiscal="notaFiscal"/>
          <px-nota-fiscal-xml-btn class="ml-2" :nota-fiscal="notaFiscal"/>
          <px-nota-fiscal-detalhe-dialog :nota-fiscal="notaFiscal">
            <template v-slot:activator="{ on }">
              <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-3" small v-on="on">
                Detalhes
              </v-btn>
            </template>
          </px-nota-fiscal-detalhe-dialog>
          <px-cadastro-nota-fiscal-vinculo-compra-dialog
            :nota-fiscal="notaFiscal"
            @change="onChangeNotaVinculo">
            <template v-slot:activator="{ on }">
              <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-3"
                     color="primary"
                     small v-on="on">
                Vincular OC
              </v-btn>
            </template>
          </px-cadastro-nota-fiscal-vinculo-compra-dialog>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <span class="caption font-weight-bold">Chave de acesso</span>
          <div>
            {{ notaFiscal.chaveAcesso }}
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <span class="caption font-weight-bold">Natureza da operação</span>
          <div>
            {{ notaFiscal.naturezaOperacao }}
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <span class="caption font-weight-bold">Destinatário</span>
          <div>
            {{ notaFiscal.comprador.pessoa.nome }}
            <div>
              {{ notaFiscal.comprador.pessoa.cnpj | cnpj }}
            </div>
            <div>
              {{ notaFiscal.enderecoDestinatario | enderecoNota }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <span class="caption font-weight-bold">Emitente</span>
          <div>
            <px-nota-fiscal-fornecedor :nota-fiscal="notaFiscal"
                                       cnpj-class=""
                                       :truncate="80"/>
            <div>
              {{ notaFiscal.enderecoEmitente | enderecoNota }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <div class="caption font-weight-bold">
            Modalidade de transporte
          </div>
          <px-nota-fiscal-modo-transporte :modo-transporte="notaFiscal.modalidadeFrete"/>
        </v-col>
      </v-row>
      <template v-if="notaFiscal.notaFiscalCompraLinks && notaFiscal.notaFiscalCompraLinks.length">
        <v-row dense class="subtitle-1 font-weight-bold mt-3">
          <v-col cols="12">
            Ordens de compra
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12">
            <px-nota-fiscal-vinculos :nota-fiscal="notaFiscal"/>
          </v-col>
        </v-row>
      </template>
      <v-row class="mt-3">
        <v-col cols="12" sm="4">
          <v-row dense class="subtitle-1 font-weight-bold">
            <v-col cols="6">
              Impostos
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              ICMS
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorIcms | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              IPI
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorIpi | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              PIS
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorPis | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Cofins
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorCofins | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              ST
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorSt | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Difal Dest.
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.valorDifalDest || 0 | currency }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4">
        </v-col>
        <v-col cols="12" sm="4">
          <v-row dense class="subtitle-1 font-weight-bold">
            <v-col cols="6">
              Totais
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalProdutos | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Total frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalFrete | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Seguro:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalSeguro | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Outros:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalOutros | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              Desconto:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalDesconto | currency }}
            </v-col>
          </v-row>
          <v-row dense class="font-weight-bold text--primary--color">
            <v-col cols="6">
              TOTAL:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ notaFiscal.totalNotaFiscal | currency }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense class="subtitle-1 font-weight-bold mt-3">
        <v-col cols="12">
          Produtos
        </v-col>
      </v-row>
      <px-nota-fiscal-item-produtos :nota-fiscal="notaFiscal"/>
    </div>
  </div>
</template>

<script>
import NotasFiscaisService from '@/modules/notas-fiscais/notas-fiscais-service';
import NotaFiscalItemProdutos from '@/modules/notas-fiscais/NotaFiscalItemProdutos.vue';
import NotaFiscalFornecedor from '@/modules/notas-fiscais/NotaFiscalFornecedor.vue';
import NotaFiscalDanfeBtn from '@/modules/notas-fiscais/NotaFiscalDanfeBtn.vue';
import NotaFiscalDetalheDialog from '@/modules/notas-fiscais/detalhes/NotaFiscalDetalheDialog.vue';
import NotaFiscalVinculos from '@/modules/notas-fiscais/NotaFiscalVinculos.vue';
import CadastroNotaFiscalVinculoCompraDialog
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoCompraDialog.vue';
import NotaFiscalXmlBtn from '@/modules/notas-fiscais/NotaFiscalXmlBtn.vue';
import NotaFiscalModoTransporte from '@/modules/notas-fiscais/NotaFiscalModoTransporte.vue';

export default {
  props: {
    notaFiscalProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notaFiscal: null,
      loading: false,
    };
  },
  methods: {
    getNotaFiscal() {
      this.loading = true;
      NotasFiscaisService.getNotaFiscal(this.notaFiscalProp.id)
        .then(({ data }) => {
          this.notaFiscal = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeNotaVinculo() {
      this.getNotaFiscal();
    },
  },
  created() {
    this.getNotaFiscal();
  },
  components: {
    pxNotaFiscalItemProdutos: NotaFiscalItemProdutos,
    pxNotaFiscalFornecedor: NotaFiscalFornecedor,
    pxNotaFiscalDanfeBtn: NotaFiscalDanfeBtn,
    pxNotaFiscalDetalheDialog: NotaFiscalDetalheDialog,
    pxNotaFiscalVinculos: NotaFiscalVinculos,
    pxCadastroNotaFiscalVinculoCompraDialog: CadastroNotaFiscalVinculoCompraDialog,
    pxNotaFiscalXmlBtn: NotaFiscalXmlBtn,
    pxNotaFiscalModoTransporte: NotaFiscalModoTransporte,
  },
};
</script>
